if (!customElements.get('gw-product-options')) {
  customElements.define('gw-product-options', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.variants = JSON.parse(this.querySelector('script').textContent).map(v => {
        const parts = v.title.split(' / ');
        const size = parts.find(p => /^(?:\d?x{0,3}[sml]|\d?xl|\d{2,3})$/i.test(p.trim()));
        return {...v, size: size || (parts.length === 1 && v.title !== 'Default Title' ? v.title : ''), colour: parts.filter(p => p !== size && p !== 'Default Title').join(' / ')};
      });
      const selected = this.variants.find(v => String(v.id) === this.dataset.selected) || this.variants.find(v => v.available) || this.variants[0];
      this.colour = selected.colour;
      this.size = selected.size;
      this.sizeRow = this.querySelector('.gw-size-buttons');
      this.water = this.querySelector('.gw-size-water');
      const sizes = [...new Set(this.variants.map(v => v.size).filter(Boolean))];
      const colours = [...new Set(this.variants.map(v => v.colour).filter(Boolean))];
      const names = {'grey blue':'graublau','gray blue':'graublau','charcoal gray':'anthrazit','medium heather gray':'grau','medium heather grey':'grau','black':'schwarz','white':'weiß','light gray':'hellgrau','light grey':'hellgrau','gray':'grau','grey':'grau','red':'rot','blue':'blau','green':'grün','pink':'rosa','brown':'braun','beige':'beige','yellow':'gelb'};
      const hex = {'grey blue':'#405363','gray blue':'#405363','charcoal gray':'#454545','medium heather gray':'#bcbcc1','medium heather grey':'#bcbcc1','black':'#171717','white':'#fff','light gray':'#cfcfcf','light grey':'#cfcfcf','gray':'#808080','grey':'#808080','red':'#bb2029','blue':'#235499','green':'#355b3d','pink':'#df92af','brown':'#664837','beige':'#d0bba0','yellow':'#e7d738'};
      sizes.forEach(size => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'gw-size-choice'; b.dataset.size = size;
        b.textContent = size.toLowerCase().replace(/^2xl$/, 'xxl').replace(/^3xl$/, 'xxxl'); b.setAttribute('role','radio');
        b.addEventListener('click', () => {this.size = size; this.select();});
        this.sizeRow.append(b);
      });
      this.querySelector('.gw-options-sizes').hidden = sizes.length === 0;
      const linkedProducts = JSON.parse(this.querySelector('[data-gw-linked-colours]')?.textContent || '[]');
      if (linkedProducts.length > 1) {
        linkedProducts.forEach(product => {
          const productColours = [...new Set(product.variants.map(v => v.title.split(' / ')[0].trim()))];
          productColours.forEach(colour => {
            const variants = product.variants.filter(v => v.title.split(' / ')[0].trim() === colour);
            const key = colour.toLowerCase();
            const link = document.createElement('a');
            link.className = 'gw-colour-choice gw-linked-colour';
            link.href = product.url;
            link.dataset.colour = colour;
            link.dataset.currentProduct = String(product.current);
            link.style.cssText = 'display:block;flex-shrink:0;box-sizing:border-box';
            link.style.setProperty('--swatch', hex[key] || '#aaa');
            if (product.print?.ink) link.style.background = 'linear-gradient(135deg,' + (hex[key] || '#aaa') + ' 50%,' + product.print.ink + ' 50%)';
            link.setAttribute('role', 'radio');
            link.setAttribute('aria-checked', String(product.current && colour === this.colour));
            link.setAttribute('aria-label', (names[key] || colour) + (product.print?.label ? ' · ' + product.print.label : ''));
            link.title = link.getAttribute('aria-label');
            link.addEventListener('click', event => {
              if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
              event.preventDefault();
              if (product.current) {
                this.colour = colour;
                if (!variants.some(v => v.available && v.title.split(' / ').at(-1) === this.size)) this.size = (variants.find(v => v.available) || variants[0]).title.split(' / ').at(-1);
                this.select();
                return;
              }
              const target = variants.find(v => v.available && v.title.split(' / ').at(-1).toLowerCase() === this.size.toLowerCase()) || variants.find(v => v.available) || variants[0];
              const url = new URL(product.url, location.origin);
              url.searchParams.set('variant', target.id);
              const preview = new URL(location.href).searchParams.get('preview_theme_id');
              if (preview) url.searchParams.set('preview_theme_id', preview);
              this.switchLinkedProduct(url, link);
            });
            this.querySelector('.gw-colour-buttons').append(link);
          });
        });
      } else colours.forEach(colour => {
        const b = document.createElement('button'); const key = colour.toLowerCase();
        b.type = 'button'; b.className = 'gw-colour-choice'; b.dataset.colour = colour;
        b.setAttribute('role','radio'); b.setAttribute('aria-label',names[key] || colour.toLowerCase()); b.title = names[key] || colour.toLowerCase();
        if (hex[key]) b.style.setProperty('--swatch',hex[key]);
        else {b.classList.add('gw-colour-unknown'); b.textContent = colour.toLowerCase();}
        b.addEventListener('click', () => {this.colour = colour;const same = this.variants.find(v => v.colour === colour && v.size === this.size && v.available);if(!same)this.size = (this.variants.find(v => v.colour === colour && v.available) || this.variants.find(v => v.colour === colour)).size;this.select();});
        this.querySelector('.gw-colour-buttons').append(b);
      });
      this.querySelector('.gw-options-colours').hidden = colours.length === 0 && linkedProducts.length < 2;
      this.names = names;
      this.querySelectorAll('[data-quantity-step]').forEach(b => b.addEventListener('click', () => {
        const input = this.querySelector('[name="quantity"]');
        input.value = Math.max(1,(parseInt(input.value,10)||1)+Number(b.dataset.quantityStep));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      this.querySelector('[name="quantity"]').addEventListener('change', e => {e.target.value = Math.max(1,parseInt(e.target.value,10)||1);});
      this.select(false);
      this.observer = new ResizeObserver(() => this.moveLine(false)); this.observer.observe(this.sizeRow);
    }
    disconnectedCallback(){this.observer?.disconnect();}

    async switchLinkedProduct(url, link) {
      const section = this.closest('.gw-universal-product');
      const wrapper = section?.closest('[id^="shopify-section-"]');
      if (!section || !wrapper) return;
      this.linkedRequest?.abort();
      const controller = new AbortController();
      this.linkedRequest = controller;
      section.setAttribute('aria-busy', 'true');
      this.querySelector('[data-linked-error]')?.remove();
      const quantity = this.querySelector('[name="quantity"]').value;
      const requestUrl = new URL(url);
      requestUrl.searchParams.set('section_id', wrapper.id.replace('shopify-section-', ''));
      try {
        const response = await fetch(requestUrl.href, {signal:controller.signal});
        if (!response.ok) throw new Error('Product request failed');
        const html = await response.text();
        if (controller.signal.aborted) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.querySelector('.gw-universal-product');
        if (!replacement?.querySelector('gw-product-options')) throw new Error('Product section missing');
        section.replaceWith(replacement);
        const input = replacement.querySelector('[name="quantity"]');
        if (input) input.value = quantity;
        history.replaceState({}, '', url.href);
        const title = replacement.querySelector('gw-product-options').dataset.pageTitle;
        if (title) document.title = title;
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.href = url.origin + url.pathname;
        document.dispatchEvent(new CustomEvent('gw:product:updated', {detail:{root:wrapper}}));
        replacement.querySelector('.gw-linked-colour[aria-checked="true"]')?.focus({preventScroll:true});
      } catch (error) {
        if (error.name === 'AbortError') return;
        const message = document.createElement('p');
        message.dataset.linkedError = '';
        message.setAttribute('role','alert');
        message.textContent = this.dataset.switchError;
        this.append(message);
        link.focus({preventScroll:true});
      } finally {
        section.removeAttribute('aria-busy');
      }
    }

    moveLine(animate = true) {
      const b = this.querySelector('.gw-size-choice[aria-checked="true"]');
      if (!b) {this.water.hidden = true;return;}
      this.water.hidden = false;
      this.water.style.width = b.offsetWidth+'px'; this.water.style.transform = `translateX(${b.offsetLeft}px)`;

    }
    select(updateUrl = true) {
      const variant = this.variants.find(v => v.size === this.size && v.colour === this.colour);
      if (!variant) return;
      const hidden = this.form.querySelector('input[name="id"]'); hidden.value = variant.id;
      this.querySelectorAll('.gw-size-choice').forEach(b => {b.disabled = !this.variants.some(v => v.size === b.dataset.size && v.colour === this.colour && v.available); b.setAttribute('aria-checked',String(b.dataset.size === this.size));});
      this.querySelectorAll('button.gw-colour-choice').forEach(b => {b.setAttribute('aria-checked',String(b.dataset.colour === this.colour));});
      this.querySelector('[data-colour-name]').textContent = this.names[this.colour.toLowerCase()] || this.colour.toLowerCase();
      const cart = this.form.querySelector('button[type="submit"]'); if(cart){cart.disabled = !variant.available;cart.textContent = variant.available ? 'in den warenkorb' : 'ausverkauft';}
      const price = this.form.closest('section').querySelector('[data-gw-universal-price],.gw-pants-product__price,.gw-shorts-product__price');
      if(price)price.textContent = new Intl.NumberFormat('de-DE',{style:'currency',currency:this.dataset.currency}).format(variant.price/100);
      this.querySelectorAll('.gw-linked-colour').forEach(link => link.setAttribute('aria-checked',String(link.dataset.currentProduct === 'true' && link.dataset.colour === this.colour)));
      this.dispatchEvent(new CustomEvent('gw:variant:changed',{bubbles:true,detail:{colour:this.colour,image:variant.featured_image?.src}}));
      this.moveLine(updateUrl);
      if(updateUrl){const url = new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
    }
  });
}
